import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconAssetGalleryStyle0 = gravityIconIndividualCss;

const GravityIconAssetGallery = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '0f9aab6575c5a7260c29cab43d3ded70baf20aba', color: this.color, size: this.size }, h("svg", { key: '8fb546fbd2f7b8a0ff07e3e89b9ed69315ebfa13', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '66119996c7ef1a3521114ca6e1fee3aef4f299e5', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5 4v-.5a.5.5 0 0 1 .5-.5h14a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5H19a.5.5 0 0 1-.5-.5v-10h-13A.5.5 0 0 1 5 4ZM2.5 6.49A.5.5 0 0 0 2 7v10.5a.5.5 0 0 0 .5.5H16a.5.5 0 0 0 .5-.5V7a.5.5 0 0 0-.5-.5L2.5 6.49ZM15 8v8.5H3.5V8H15Zm-4.19 3.24-2.3 3.31L7 12.3a.21.21 0 0 0-.33 0L5 14.69a.2.2 0 0 0 .16.31h8.24a.2.2 0 0 0 .16-.31l-2.39-3.45a.2.2 0 0 0-.36 0ZM9 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z", fill: "currentColor" }))));
    }
};
GravityIconAssetGallery.style = GravityIconAssetGalleryStyle0;

export { GravityIconAssetGallery as gravity_icon_asset_gallery };

//# sourceMappingURL=gravity-icon-asset-gallery.entry.js.map